import { get } from "@insite/client-framework/Services/ApiService";
import { GalleryResultsModel, GetImageGalleryApiParameter } from "@store/Store/Data/Gallery/Handlers/GetImageGallery";

const galleryUrl = "api/v1/rssw/gallery/list";

export async function getGallery(parameter: GetImageGalleryApiParameter): Promise<GalleryResultsModel> {
    const params: GetImageGalleryApiParameter = { ...parameter };
    try {
        const galleryModel = await get<any>(`${galleryUrl}`, params);
        return {
            result: galleryModel,
        };
    } catch (error) {
        return {
            result: [],
        };
    }
}
